import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useLocation, Link as RouterLink } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path: string;
  isLast: boolean;
}

const BreadCrumb: React.FC = () => {
  const location = useLocation();

  const getBreadcrumbItems = (): BreadcrumbItem[] => {
    const pathnames = location.pathname.split('/').filter(Boolean);

    return pathnames.map((segment, index) => ({
      label: formatSegmentLabel(segment),
      path: `/${pathnames.slice(0, index + 1).join('/')}`,
      isLast: index === pathnames.length - 1,
    }));
  };

  const formatSegmentLabel = (segment: string): string => {
    // Handle kebab-case, snake_case, or regular segments
    return segment
      .split(/[-_]/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const breadcrumbItems = getBreadcrumbItems();

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      {/* <Link component={RouterLink} to="/" underline="hover" color="inherit">
        Home
      </Link> */}

      {breadcrumbItems.map(({ label, path, isLast }) =>
        isLast ? (
          <Typography color="text.primary" key={path}>
            {label}
          </Typography>
        ) : (
          <Link component={RouterLink} to={path} underline="none" color="inherit" key={path}>
            {label}
          </Link>
        )
      )}
    </Breadcrumbs>
  );
};

export default BreadCrumb;
